import React, { Component } from 'react';
import $ from 'jquery';

import SideNav from '../Common/SideNav';
import Nav from '../Common/Nav';
import Footer from '../Common/Footer';
import PushMenu from '../Util/PushMenu';

const Selector = {
    TOGGLE_BUTTON: '[data-widget="pushmenu"]',
    DATA_TOGGLE: '[data-widget="control-sidebar"]'
};

class index extends Component { // NOSONAR

    componentDidMount() {
        $(document).on('click', Selector.TOGGLE_BUTTON, (event) => {
            event.preventDefault();

            let button = event.currentTarget;

            if ($(button).data('widget') !== 'pushmenu') {
                button = $(button).closest(Selector.TOGGLE_BUTTON);
            }

            PushMenu._jQueryInterface.call($(button), 'toggle');
        });

        $(window).on('load', () => {
            PushMenu._jQueryInterface.call($(Selector.TOGGLE_BUTTON));
        });

    }

    render() {
        return (
            <div className="wrapper">
                <Nav />
                <aside className="main-sidebar sidebar-dark-primary elevation-4">
                    <SideNav props={this.props} />
                </aside>
                <div className="content-wrapper">
                    {this.props.children}
                </div>
                <Footer />
            </div>
        );
    }

}
export default index;
